import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
	Box,
	Button,
	FormControl,
	FormLabel,
	Heading,
	Textarea,
} from '@chakra-ui/react';
import { options, services } from './data';

export const Settings = () => {
	const [loading, setLoading] = useState(true);
	const [markdown, setMarkdown] = useState({});
	const [wake, setWake] = useState(0);

	useEffect(() => {
		let active = true;
		async function load() {
			const res = await axios.get('/markdown', options());
			if (!active) {
				return;
			}
			setMarkdown(
				res.data.markdown.reduce(
					(acc, { place, content }) => ({ ...acc, [place]: content }),
					{}
				)
			);
			setLoading(false);
		}
		load();

		return () => {
			active = false;
		};
	}, [wake]);

	const onChange = ({ target: { name, value } }) =>
		setMarkdown({ ...markdown, [name]: value });

	const handleUpdate = key =>
		axios({
			method: 'put',
			url: `/markdown`,
			data: {
				place: key,
				content: markdown[key],
			},
			...options(),
		})
			.then(() => {
				setWake(new Date().getTime());
			})
			.catch(console.log);

	if (loading) return <p>Loading...</p>;

	return (
		<Box w="60%">
			{Object.keys(services).map(serviceKey => (
				<Box pb={6} key={serviceKey}>
					<Heading pb={6} fontSize={'xl'}>
						{`Process and materials for «${services[serviceKey]}» service`}
					</Heading>
					<FormControl pb={3}>
						<FormLabel>Process description</FormLabel>
						<Textarea
							rows={10}
							value={markdown[`${serviceKey}:`]}
							name={`${serviceKey}:`}
							onChange={onChange}
							size="sm"
						/>
						<Button
							d="block"
							w="100%"
							colorScheme="blue"
							onClick={() => handleUpdate(`${serviceKey}:`)}
						>
							{`Update «${services[serviceKey]}» process description`}
						</Button>
					</FormControl>
					<FormControl pb={3}>
						<FormLabel>Documents checklist</FormLabel>
						<Textarea
							rows={10}
							value={markdown[`${serviceKey}:1`]}
							name={`${serviceKey}:1`}
							onChange={onChange}
							size="sm"
						/>
						<Button
							d="block"
							w="100%"
							colorScheme="blue"
							onClick={() => handleUpdate(`${serviceKey}:1`)}
						>
							{`Update «${services[serviceKey]}» documents checklist`}
						</Button>
					</FormControl>
					<FormControl pb={3}>
						<FormLabel>Stage 2 materials</FormLabel>
						<Textarea
							rows={10}
							value={markdown[`${serviceKey}:2`]}
							name={`${serviceKey}:2`}
							onChange={onChange}
							size="sm"
						/>
						<Button
							d="block"
							w="100%"
							colorScheme="blue"
							onClick={() => handleUpdate(`${serviceKey}:2`)}
						>
							{`Update «${services[serviceKey]}» stage 2 materials`}
						</Button>
					</FormControl>
				</Box>
			))}
		</Box>
	);
};
